import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { DecisionMakerResponsePagePrefetchedDataProps } from 'src/app/pages/decisionMakerResponse/details/pageContext';
import {
	DecisionMakerResponsePageContextProvider,
	prefetchPageContext,
} from 'src/app/pages/decisionMakerResponse/details/pageContext';

import { Layout } from '../layout';

import { DecisionMakerResponseErrorHandler } from './ErrorHandler';

export const DecisionMakerResponse = withPrefetchedData(
	function DecisionMakerResponse({ prefetchedData }: DecisionMakerResponsePagePrefetchedDataProps): JSX.Element {
		const { petitionSlugOrId, responseId } = useKnownAvailableParams<{
			petitionSlugOrId: string;
			responseId: string;
		}>();

		return (
			<DecisionMakerResponsePageContextProvider
				petitionSlugOrId={petitionSlugOrId}
				responseId={responseId}
				prefetchedData={prefetchedData}
				errorHandler={DecisionMakerResponseErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</DecisionMakerResponsePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [Layout],
		prefetchData: async (context) =>
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			prefetchPageContext(context.params.petitionSlugOrId!, context.params.responseId!, context),
	},
);
